const CategoriesIcon = ({ size = 22 }) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 24 24">
    <rect x="3" y="3" width="7" height="7" rx="2" stroke="#1976d2" strokeWidth="2"/>
    <rect x="14" y="3" width="7" height="7" rx="2" stroke="#1976d2" strokeWidth="2"/>
    <rect x="14" y="14" width="7" height="7" rx="2" stroke="#1976d2" strokeWidth="2"/>
    <rect x="3" y="14" width="7" height="7" rx="2" stroke="#1976d2" strokeWidth="2"/>
  </svg>
);
export default CategoriesIcon;